/* import __COLOCATED_TEMPLATE__ from './admin-bubble.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();